








import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class PeriodBtn extends Vue {
  @Prop() periodType?: string;
  @Prop() selectedPeriod?: string;

  get labelKey() {
    let tempKey = '';
    switch (this.periodType) {
      case 'all':
        tempKey = 'COMMON_ALL';
        break;
      case 'td':
        tempKey = 'COMMON_TODAY';
        break;
      case 'ytd':
        tempKey = 'COMMON_YESTERDAY';
        break;
      case '3d':
        tempKey = 'COMMON_3_DAY';
        break;
      case '6d':
        tempKey = 'COMMON_6_DAY';
        break;
      case '7d':
        tempKey = 'COMMON_7_DAY';
        break;
      case '60d':
        tempKey = 'COMMON_60_DAY';
        break;
      case '6d1w':
        tempKey = 'COMMON_1_WEEK';
        break;
      case '1w':
        tempKey = 'COMMON_1_WEEK';
        break;
      case '30d':
        tempKey = 'COMMON_30_DAY';
        break;
      case '1m':
        tempKey = 'COMMON_1_MONTH';
        break;
      case '1m29d':
        tempKey = 'COMMON_1_MONTH';
        break;
      case '2m':
        tempKey = 'COMMON_2_MONTH';
        break;
      case '90d':
        tempKey = 'COMMON_90_DAY';
        break;
      case '3m':
        tempKey = 'COMMON_3_MONTH';
        break;
      case '6m':
        tempKey = 'COMMON_6_MONTH';
        break;
      case '1y':
        tempKey = 'COMMON_1_YEAR';
        break;
    }
    return tempKey;
  }

  private clickPeriod() {
    this.$emit('changePeriod', this.periodType);
  }
}
